var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { padding: "10px", color: "#d9d9d9" } }, [
        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcrTip2")))
      ]),
      _c("div", { staticClass: "result-form-se" }, [
        _c("div", { style: { cursor: "pointer", width: "100%" } }, [
          _c(
            "div",
            { staticClass: "row", staticStyle: { position: "relative" } },
            [
              _c(
                "div",
                {
                  staticClass: "item1",
                  staticStyle: {
                    "font-weight": "bold",
                    color: "white",
                    "background-color": "#3f3f3f"
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FieldName")))
                  ])
                ]
              ),
              _vm.showBookRecognitionResults
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        left: "105px",
                        top: "6px",
                        padding: "2px",
                        "background-color": "white",
                        cursor: "pointer"
                      },
                      on: {
                        click: function($event) {
                          _vm.showBookRecognitionResults = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PackUp")))]
                  )
                : _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        left: "105px",
                        top: "6px",
                        padding: "2px",
                        "background-color": "white",
                        cursor: "pointer"
                      },
                      on: {
                        click: function($event) {
                          _vm.showBookRecognitionResults = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExpandAll")))]
                  ),
              _vm.showBookRecognitionResults
                ? _c(
                    "div",
                    {
                      staticClass: "item2",
                      staticStyle: {
                        "font-weight": "bold",
                        color: "white",
                        "background-color": "#3f3f3f"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_BookRecognitionResults"))
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "item3",
                  staticStyle: {
                    "font-weight": "bold",
                    color: "white",
                    "background-color": "#abd08e"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmedBusinessData")))]
              )
            ]
          ),
          _vm.currentOcrRecognitionFields &&
          _vm.currentOcrRecognitionFields.length > 0
            ? _c(
                "div",
                _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                  return _c("div", { key: item.code }, [
                    item.code === _vm.SystemConstants.OCR_FIELD_BILL_NO.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BLNo")) + " "
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              model: {
                                value: _vm.job.billNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "billNo", $$v)
                                },
                                expression: "job.billNo"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_ORDER_TYPE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c(
                              "el-select",
                              {
                                staticClass: "item3",
                                class:
                                  !_vm.job.orderType &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  placeholder:
                                    !_vm.job.orderType &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : "",
                                  no: "orderType",
                                  clearable: ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  }
                                },
                                model: {
                                  value: _vm.job.orderType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "orderType", $$v)
                                  },
                                  expression: "job.orderType"
                                }
                              },
                              _vm._l(_vm.blModeList, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.serialNumber
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_BL_NUMBER.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_NumberOfOriginalCopies"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              model: {
                                value: _vm.job.blNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "blNumber", $$v)
                                },
                                expression: "job.blNumber"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 6,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: { rows: 6, type: "textarea" },
                              model: {
                                value: _vm.job.shipper,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipper", $$v)
                                },
                                expression: "job.shipper"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 6,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: { rows: 6, type: "textarea" },
                              model: {
                                value: _vm.job.consignee,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consignee", $$v)
                                },
                                expression: "job.consignee"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 6,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: { rows: 6, type: "textarea" },
                              model: {
                                value: _vm.job.notify,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notify", $$v)
                                },
                                expression: "job.notify"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_CONTAINER_LOAD_TYPE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_FLCLType"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                filterable: "",
                                no: "containerLoadType",
                                clearable: "",
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_ImportConstants$_cargoTypeInputList,
                                "callback-method-type": "value",
                                "default-value": _vm.job.containerLoadType,
                                "tag-name":
                                  _vm.$store.getters.language === "zh"
                                    ? "chineseName"
                                    : "englishName",
                                "tag-value": "code",
                                "callback-params": { key: "containerLoadType" }
                              },
                              on: {
                                parentCallBack: function(obj) {
                                  return _vm.pm.qCargoType_Change(obj)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_CARRIER.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-company-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.carrierId &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                "method-params": {
                                  companyLob: "seaExport",
                                  seaCmp: true,
                                  active: true
                                },
                                "default-value": _vm.job.carrierId || "",
                                placeholder:
                                  !_vm.job.carrierId &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                change: function(p) {
                                  _vm.job.carrierId = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_VESSEL.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Payment.vessel")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "vessel",
                                "select-type":
                                  _vm.selectTypeNames.static_data_Vessel,
                                cache: false,
                                filterable: "",
                                "allow-create": true,
                                "default-value": _vm.job.vessel,
                                "static-options": _vm.vesselList
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.onVesselSelectionChange(p)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Payment.voyage")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "item3",
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "item3",
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  },
                                  model: {
                                    value: _vm.job.voyageFlight,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "voyageFlight", $$v)
                                    },
                                    expression: "job.voyageFlight"
                                  }
                                }),
                                _vm.showChooseShippingSchedulesBtn
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          "background-color": "#169bd5"
                                        },
                                        attrs: { type: "primary" },
                                        on: { click: _vm.btnVayageShowHandle }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ChooseShippingSchedules"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_ETD.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.dateOfDeparture"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-date-picker", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                value: _vm.job.etd,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.etdChange }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_FREIGHT_TERM.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.TransportationClause")
                                  )
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.freightTerm &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "freightTerm",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_ShippingTerm,
                                filterable: "",
                                clearable: "",
                                "default-value": _vm.job.freightTerm,
                                placeholder:
                                  !_vm.job.freightTerm &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                parentCallBack: function(p) {
                                  _vm.job.freightTerm = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FreightTerm")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.paymentTermMBL &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_PaymentTerm,
                                filterable: "",
                                clearable: "",
                                "default-value": _vm.job.paymentTermMBL,
                                placeholder:
                                  !_vm.job.paymentTermMBL &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                parentCallBack: function(p) {
                                  _vm.job.paymentTermMBL = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_CONTAINER_INFOS.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_CartonQuantity")
                                  )
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "item3",
                                staticStyle: { "overflow-y": "auto" },
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "column",
                                          "max-height": "200px"
                                        }
                                      },
                                      _vm._l(_vm.job.seaEQ, function(
                                        item,
                                        index
                                      ) {
                                        return _c("div", { key: index }, [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: { width: "49%" }
                                                },
                                                [
                                                  _c("el-input-number", {
                                                    staticClass: "item3-1",
                                                    staticStyle: {
                                                      width: "40px"
                                                    },
                                                    attrs: {
                                                      controls: false,
                                                      no: "eqQuantity"
                                                    },
                                                    model: {
                                                      value: item.eqQuantity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "eqQuantity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.eqQuantity"
                                                    }
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "5px"
                                                      }
                                                    },
                                                    [_vm._v("X")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    staticClass: "item3-1",
                                                    staticStyle: {
                                                      width: "60px",
                                                      "margin-left": "5px"
                                                    },
                                                    attrs: {
                                                      no: "eqSize",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .local_cache_EQSize,
                                                      fields: ["code"],
                                                      filterable: "",
                                                      placeholder: " ",
                                                      "show-copy": false,
                                                      "default-value":
                                                        item.eqSize,
                                                      "tag-name": "code"
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.changeSizeCallBack(
                                                          item,
                                                          p
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("cargo-advance-select", {
                                                    staticClass: "item3-1",
                                                    staticStyle: {
                                                      width: "60px",
                                                      "margin-left": "5px"
                                                    },
                                                    attrs: {
                                                      no: "eqType",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .basic_data_EQType,
                                                      fields: ["code"],
                                                      filterable: "",
                                                      placeholder: " ",
                                                      "show-copy": false,
                                                      "default-value":
                                                        item.eqType,
                                                      "tag-name": "code"
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.changeTypeCallBack(
                                                          item,
                                                          p
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#1398f1",
                                                    "margin-left": "5px",
                                                    "font-size": "25px",
                                                    cursor: "pointer"
                                                  },
                                                  on: { click: _vm.addSeaEQ }
                                                },
                                                [_vm._v("+")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#1398f1",
                                                    "margin-left": "5px",
                                                    "font-size": "25px",
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteSeaEQ(
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("-")]
                                              )
                                            ]
                                          )
                                        ])
                                      }),
                                      0
                                    ),
                                    !_vm.job.seaEQ || _vm.job.seaEQ.length === 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "#1398f1",
                                              "margin-top": "10px",
                                              "margin-left": "5px",
                                              cursor: "pointer"
                                            },
                                            on: { click: _vm.addSeaEQ }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Add")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_INCO_TERM.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("queryJob.IncoTerm")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.incoTerm &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "incoTerm",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_IncoTerm,
                                filterable: "",
                                clearable: "",
                                "default-value": _vm.job.incoTerm,
                                placeholder:
                                  !_vm.job.incoTerm &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                parentCallBack: function(p) {
                                  _vm.job.incoTerm = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_PAYMENT_PLACE_BL.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.PlaceOfPayment"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              model: {
                                value: _vm.job.paymentPlaceBL,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "paymentPlaceBL", $$v)
                                },
                                expression: "job.paymentPlaceBL"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_TD_SIGN_PLACE_BL.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PlaceOfIssue")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              model: {
                                value: _vm.job.signPlaceBL,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "signPlaceBL", $$v)
                                },
                                expression: "job.signPlaceBL"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_TD_SIGN_DATE_BL.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfIssue")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-date-picker", {
                              staticClass: "item3",
                              class: { "input-red": item.redColor },
                              attrs: {
                                value: _vm.job.signDateBL,
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: {
                                input: function(value) {
                                  _vm.job.signDateBL = value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_HS_CODE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s("HSCode"))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 6,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: { rows: 6, type: "textarea" },
                              model: {
                                value: _vm.job.hsCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "hsCode", $$v)
                                },
                                expression: "job.hsCode"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_DISPATCHING_PLACE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.PlaceOfReceipt"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              model: {
                                value: _vm.job.dispatchingPlace,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "dispatchingPlace", $$v)
                                },
                                expression: "job.dispatchingPlace"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Payment.portOfLoading")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.loadingPortCode &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "englishName",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.job.loadingPortCode,
                                "tag-name": "englishName",
                                placeholder:
                                  !_vm.job.loadingPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                parentCallBack: function(p) {
                                  _vm.pm.changeLoadingPortCode(p)
                                  _vm.pm.checkVesselLine()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_DISCHARGING_PORT_CODE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.dischargingPortCode"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.dischargingPortCode &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "dischargingPortCode",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.job.dischargingPortCode,
                                placeholder:
                                  !_vm.job.dischargingPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                parentCallBack: function(p) {
                                  _vm.job.dischargingPortCode = p.value
                                  _vm.pm.dischargingPortCodeChange(
                                    p.value,
                                    _vm.job.carrierId
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_DESTINATION_PORT_CODE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.placeOfDelivery"))
                                )
                              ]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-advance-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.destinationPortCode &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "destinationPortCode",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.job.destinationPortCode,
                                placeholder:
                                  !_vm.job.destinationPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                parentCallBack: function(p) {
                                  _vm.job.destinationPortCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_QUANTITY.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input-number", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item),
                                textAlign: "left"
                              },
                              attrs: {
                                controls: false,
                                no: "quantityContract"
                              },
                              model: {
                                value: _vm.job.quantityContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "quantityContract", $$v)
                                },
                                expression: "job.quantityContract"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_PACKING.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Package")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-packing-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.packing &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "packing",
                                "default-value": _vm.job.packing,
                                placeholder:
                                  !_vm.job.packing &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                change: function(p) {
                                  _vm.job.packing = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_INSIDE_QUANTITY.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Pieces2")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input-number", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item),
                                textAlign: "left"
                              },
                              attrs: { controls: false, no: "insideQuantity" },
                              model: {
                                value: _vm.job.insideQuantity,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "insideQuantity", $$v)
                                },
                                expression: "job.insideQuantity"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_INSIDE_PACKING.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PiecesType2")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("cargo-packing-select", {
                              staticClass: "item3",
                              class:
                                !_vm.job.insidePacking &&
                                _vm.resultJson[item.code] &&
                                !_vm.resultJson[
                                  item.code + "_notShowPlaceholder"
                                ]
                                  ? "color-red"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                no: "insidePacking",
                                "default-value": _vm.job.insidePacking,
                                placeholder:
                                  !_vm.job.insidePacking &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? _vm.resultJson[item.code]
                                    : ""
                              },
                              on: {
                                clear: function($event) {
                                  return _vm.clear(item)
                                },
                                change: function(p) {
                                  _vm.job.insidePacking = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_GROSS_WEIGHT.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Weight")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input-number", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item),
                                textAlign: "left"
                              },
                              attrs: {
                                precision: 3,
                                controls: false,
                                no: "weightContract"
                              },
                              model: {
                                value: _vm.job.weightContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightContract", $$v)
                                },
                                expression: "job.weightContract"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_CUBAGE.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("div", { staticClass: "item2" }, [
                                  _vm._v(_vm._s(_vm.resultJson[item.code]))
                                ])
                              : _vm._e(),
                            _c("el-input-number", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item),
                                textAlign: "left"
                              },
                              attrs: {
                                precision: 3,
                                controls: false,
                                no: "cubageContract"
                              },
                              model: {
                                value: _vm.job.cubageContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageContract", $$v)
                                },
                                expression: "job.cubageContract"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_MARK.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Marks")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 6,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: { rows: 6, type: "textarea", no: "mark" },
                              model: {
                                value: _vm.job.mark,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mark", $$v)
                                },
                                expression: "job.mark"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Pricing.Goods")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 6,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              class:
                                _vm.job.ifContainSensitiveWord === true
                                  ? "color-yellow"
                                  : "",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: {
                                rows: 6,
                                type: "textarea",
                                no: "cargoEnglishName"
                              },
                              model: {
                                value: _vm.job.cargoEnglishName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cargoEnglishName", $$v)
                                },
                                expression: "job.cargoEnglishName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code === _vm.SystemConstants.OCR_FIELD_REMARKS.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item1",
                                style: { color: _vm.getFieldColor(item) }
                              },
                              [_vm._v(_vm._s(_vm.$t("Payment.remarks")))]
                            ),
                            _vm.showBookRecognitionResults
                              ? _c("el-input", {
                                  staticClass: "item2",
                                  attrs: {
                                    disabled: "",
                                    rows: 5,
                                    type: "textarea"
                                  },
                                  model: {
                                    value: _vm.resultJson[item.code],
                                    callback: function($$v) {
                                      _vm.$set(_vm.resultJson, item.code, $$v)
                                    },
                                    expression: "resultJson[item.code]"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticClass: "item3",
                              style: {
                                borderColor: _vm.getValueBorderColor(item)
                              },
                              attrs: { rows: 5, type: "textarea" },
                              model: {
                                value: _vm.job.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "remarks", $$v)
                                },
                                expression: "job.remarks"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    item.code ===
                    _vm.SystemConstants.OCR_FIELD_CONTAINER_DATA.code
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            on: {
                              click: function($event) {
                                return _vm.handleFocus(item.code)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  width: "100%",
                                  position: "relative"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "6px",
                                      padding: "2px",
                                      "background-color": "#169bd5",
                                      cursor: "pointer",
                                      color: "#169bd5"
                                    }
                                  },
                                  [_vm._v(_vm._s("."))]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { padding: "10px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ContainerInfo2")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "26", type: "primary" },
                                    on: { click: _vm.addContainer }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "27", type: "danger" },
                                    on: { click: _vm.deleteContainer }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_OrderDelete")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-top": "5px"
                                    }
                                  },
                                  [
                                    _c("cargo-ag-grid", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "200px"
                                      },
                                      attrs: {
                                        "grid-options": _vm.gridOptions,
                                        "column-defs": _vm.columnDefs,
                                        "row-data": _vm.job.container
                                      },
                                      on: {
                                        gridReady: function(params) {
                                          _vm.gridApi = params.api
                                        }
                                      }
                                    }),
                                    _c("div", {
                                      staticStyle: { "padding-top": "10px" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e()
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "fieldValidDialog",
            visible: _vm.fieldValidDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "630px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fieldValidDialog, "visible", $event)
            }
          }
        },
        [
          _vm._l(_vm.fieldValidDialog.fieldValidResults, function(
            fieldValidResultByBook,
            index
          ) {
            return _c(
              "div",
              { key: index },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_Book") +
                        (fieldValidResultByBook.index + 1)
                    )
                  )
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: fieldValidResultByBook.data }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "fieldName",
                        label: _vm.$t("CargoMsg.Cargo_FieldName"),
                        width: "180"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exceptionReason",
                        label: _vm.$t("CargoMsg.Cargo_ErrorCause"),
                        width: "400"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.fieldValidDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("shipping-schedule-dialog", {
        ref: "voyageShowDialog",
        attrs: {
          "append-to-body": "",
          visible: _vm.voyageShowDialog,
          callback: _vm.callbackShippingScheduleHanle
        },
        on: {
          "update:visible": function($event) {
            _vm.voyageShowDialog = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }